<template>
  <div id="app">
    <k-header></k-header>
    <div id="wrapper">
      <router-view/>
      <k-footer></k-footer>
    </div>
  </div>
</template>

<script>
import KHeader from '@/components/Header'
import KFooter from '@/components/Footer'
export default {
  components: {
    'k-header': KHeader,
    'k-footer': KFooter
  },
  name: 'App'
}
</script>

<style lang="sass">
  @import 'assets/sass/main'
</style>



// WEBPACK FOOTER //
// src/App.vue